import {
  createCommissionService,
  deleteCommissionService,
  getCommissionsService,
  updateCommissionService,
} from "@/services/commissions.service";
import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";

const COMMISSIONS_KEY = ["commissions"] as const;

interface CommissionFilters {
  limit?: number;
  offset?: number;
}

export const useCommissions = (filters: CommissionFilters = {}) =>
  useQuery({
    queryKey: [...COMMISSIONS_KEY, filters],
    queryFn: async () => {
      const {data} = await getCommissionsService(filters);
      if (data === undefined) throw new Error("No data");
      return data;
    },
  });

export const useCreateCommission = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: Parameters<typeof createCommissionService>[0]) => createCommissionService(body),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: COMMISSIONS_KEY});
    },
  });
};

export const useUpdateCommission = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({id, body}: {id: string; body: Parameters<typeof updateCommissionService>[1]}) =>
      updateCommissionService(id, body),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: COMMISSIONS_KEY});
    },
  });
};

export const useDeleteCommission = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteCommissionService(id),
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: COMMISSIONS_KEY});
    },
  });
};
